/*
 * @Description: 设置默认参数
 * @Date: 2021-11-02 17:01:27
 */

import dateFormat from '@/tools/dateFormat';

/**
 * @description: 设置默认参数，写死的与跳转进入的。部分字段需要转义，在此处理
 * @param {object} query 路由参数 auditStatus dataState默认全局默认
 * @return {object} 整合之后的对象
 */
export default (query = {}, projectDetail) => {
  const {
    fullName,
    userName,
    phone,
    auditStatus,
    dataState = '0',
    statementId, // 提交任务-当前结算数据id，存在则证明其他页面中打开
    finishDtStart,
    finishDtEnd,
    userIdParam,
    reviewProgress = '0',
    activityName
  } = query;

  // 注册使用字段
  const data = {
    auditStatus,
    dataState,
    userName: fullName || userName,
    phone,
    statementId,
    userIdParam,
    activityName
  };
  /* 
    追加字段并整理格式
    这些字段都有默认值，但是其他页面进入时不需要
  */
  if (!statementId) {
    data.reviewProgress = reviewProgress || '0';
    // 协定服务乙方上传不设置默认值
    if (projectDetail.fileUpSource !== 1) {
      data.auditStatus = auditStatus || '1';
    }

    data.finishDtStart =
      finishDtStart ||
      dateFormat(
        new Date(new Date().getFullYear(), new Date().getMonth() - 1, 1),
        'YYYY-MM-DD'
      );
    data.finishDtEnd = finishDtEnd || dateFormat(new Date(), 'YYYY-MM-DD');
  }

  // 清除空值字段
  for (let key in data) {
    if (data[key] === '' || data[key] === undefined) {
      delete data[key];
    }
  }
  return data;
};
